export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Cn-ea0494eaaa051ac0c9a1ec4aa6520baf.eot";